var chunkMapping = {
	"42": [
		4042
	],
	"209": [
		6362
	],
	"436": [
		436
	],
	"538": [
		9538
	],
	"725": [
		6725
	],
	"807": [
		807
	],
	"887": [
		4887
	]
};
var idToExternalAndNameMapping = {
	"436": [
		"default",
		"./App",
		2994
	],
	"807": [
		"default",
		"./AccessControlApp",
		2965
	],
	"4042": [
		"default",
		"./App",
		9961
	],
	"4887": [
		"default",
		"./App",
		5947
	],
	"6362": [
		"default",
		"./App",
		1786
	],
	"6725": [
		"default",
		"./AppV2",
		9961
	],
	"9538": [
		"default",
		"./App",
		1108
	]
};
var idToRemoteMap = {
	"436": [
		{
			"externalType": "script",
			"name": "bizhq_maps_mfe"
		}
	],
	"807": [
		{
			"externalType": "script",
			"name": "access_control"
		}
	],
	"4042": [
		{
			"externalType": "script",
			"name": "khq_reporting_ui_mfe"
		}
	],
	"4887": [
		{
			"externalType": "script",
			"name": "khq_service_ui_mfe"
		}
	],
	"6362": [
		{
			"externalType": "script",
			"name": "broadcast_ui"
		}
	],
	"6725": [
		{
			"externalType": "script",
			"name": "khq_reporting_ui_mfe"
		}
	],
	"9538": [
		{
			"externalType": "script",
			"name": "khq_drop_ui_mfe"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"436": {
		"shareScope": "default",
		"name": "./App",
		"externalModuleId": 2994,
		"remoteName": "bizhq_maps_mfe"
	},
	"807": {
		"shareScope": "default",
		"name": "./AccessControlApp",
		"externalModuleId": 2965,
		"remoteName": "access_control"
	},
	"4042": {
		"shareScope": "default",
		"name": "./App",
		"externalModuleId": 9961,
		"remoteName": "khq_reporting_ui_mfe"
	},
	"4887": {
		"shareScope": "default",
		"name": "./App",
		"externalModuleId": 5947,
		"remoteName": "khq_service_ui_mfe"
	},
	"6362": {
		"shareScope": "default",
		"name": "./App",
		"externalModuleId": 1786,
		"remoteName": "broadcast_ui"
	},
	"6725": {
		"shareScope": "default",
		"name": "./AppV2",
		"externalModuleId": 9961,
		"remoteName": "khq_reporting_ui_mfe"
	},
	"9538": {
		"shareScope": "default",
		"name": "./App",
		"externalModuleId": 1108,
		"remoteName": "khq_drop_ui_mfe"
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}